import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import useIsInHeroModule from '@hooks/useIsInHeroModule'
import {
  IMAGE_HEIGHT,
  IMAGE_HEIGHT_HERO,
} from '@components/TeaserStandardHorizontal/utils'

interface StyledTextWrapperProps {
  isInHeroModule: boolean
}

const StyledTextWrapper = styled.div<StyledTextWrapperProps>`
  ${({
    theme: {
      spacing: { spacing8, spacing16, spacing4 },
    },
    isInHeroModule,
  }) => {
    const imageSize = isInHeroModule ? IMAGE_HEIGHT_HERO : IMAGE_HEIGHT
    return css`
      position: absolute;
      bottom: ${spacing8};
      right: ${spacing16};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: calc(100% - ${imageSize}px - 8px - 16px);
      gap: ${spacing4};
      z-index: 1;
    `
  }}
`

interface TextWrapperProps {
  children: ReactNode
}

const TextWrapper: FunctionComponent<TextWrapperProps> = ({ children }) => {
  const isInHeroModule = useIsInHeroModule()
  return (
    <StyledTextWrapper isInHeroModule={isInHeroModule}>
      {children}
    </StyledTextWrapper>
  )
}

export default TextWrapper
